
import Formsy from 'formsy-react'
import React, { Component } from 'react'
import { Form } from 'formsy-semantic-ui-react';
import { Grid } from 'semantic-ui-react'
import BusinessOfferings from '../BusinessOfferings'
import { getAllCategories } from '../../../services/categories'
import './GetStarted.less'
import next from '../../../assets/images/newui/sellersignup/next-btn.svg'
import { withRouter } from 'react-router'
import ErrorBox from '../ErrorBox';
import { getPlans } from 'services/subscription';
import { pageView } from '../../../common/analytics';
import utilityMethods from '../../../utils/utilityMethods';

export class GetStarted extends Component {
    constructor(props) {
        super(props)
        this.state = {
            categories: [],
            orignalCategories: []
        }
    }

    componentDidMount() {
        pageView('/business/signup', 'Get Started');
        getAllCategories().then(res => {
            this.setState({ categories: res.data.map((item) => ({ text: item.name, value: item.categoryID })), orignalCategories: res.data });
        })
    }

    onValidSubmit = (formValue) => {
        const selectedCategory = this.state.orignalCategories.find(c => c.categoryID == formValue.categoryID);
        if (selectedCategory.marketingRedirectURL) {
            utilityMethods.setSignupInfo({ ...formValue })
            window.open(selectedCategory.marketingRedirectURL, "_self");
            return;
        }
        utilityMethods.resetSignupInfo();
        this.props.onChange({ ...formValue });
        this.props.moveToNextTab();
    }

    onCategoryChange = (e, data) => {
        this.props.onChange({ selectedCategory: this.state.orignalCategories.find(item => item.categoryID == data.value) });
        getPlans(data.value).then(res => {
            this.props.onChange({ plans: res.data });
        })
    }

    render() {
        return <div className='get-started-container'>
            <div className='get-started-top'>
                <div className='get-started-top-container'>
                    <div className='get-started-top-left'>
                        <BusinessOfferings hideFeatures={window.innerWidth < 768} />
                    </div>
                    <div className='get-started-top-right'>
                        <div className='get-started-top-arrow-img'>
                            <img src='https://com-syndafy-dealgrace-static.s3.us-east-2.amazonaws.com/arrow_1gmhgfx4krkwqmxy_.svg' />
                        </div>
                        <div className='get-started-form-container'>
                            <Formsy className='get-started-form' onValidSubmit={this.onValidSubmit}>
                                <div className='form-main-heading'>Let's Get Started</div>
                                <div className='form-sub-heading'>Select your business category</div>
                                <Grid.Column mobile={16} tablet={16} computer={16}>
                                    <Form.Dropdown
                                        selectOnBlur={false}
                                        tabIndex={4}
                                        name="categoryID"
                                        placeholder="Select Category"
                                        selection
                                        required
                                        fluid
                                        className="multi-select category"
                                        validationErrors={{
                                            isDefaultRequiredValue: 'Category is required',
                                        }}
                                        onChange={this.onCategoryChange}
                                        label="Category"
                                        errorLabel={<div className="error-label" />}
                                        options={this.state.categories}
                                        value={this.props.formState.categoryID}
                                    />
                                </Grid.Column>
                                {this.state.error ? <ErrorBox message={this.state.error} /> : ''}

                                <div className='get-started-btn-group'>
                                    <button className='get-started-btn-next' tabIndex={6} type='submit'>Next <img src={next} /></button>
                                </div>
                            </Formsy>
                            <div className='get-started-form-img'>
                                <img src={window.innerWidth > 1280 ? 'https://com-syndafy-dealgrace-static.s3.us-east-2.amazonaws.com/form-right_1gmhgfx4krkwvt32_.png' : 'https://com-syndafy-dealgrace-static.s3.us-east-2.amazonaws.com/form-right-tablet_1gmhgfwwkrkwv6r3_.png'} />
                            </div>
                        </div>
                    </div>
                    <div className='get-started-top-cube'><img src='https://com-syndafy-dealgrace-static.s3.us-east-2.amazonaws.com/form-cube_1gmhgfwpkrkwufej_.png' /></div>
                </div>
            </div>
            {window.innerWidth < 768 ? <div className='get-started-features-mobile'>
                <BusinessOfferings hideHeadings={true} />
            </div> : ''}
            <div className='get-started-bottom'>
                <div className='get-started-bottom-left'>
                    <img src='https://com-syndafy-dealgrace-static.s3.us-east-2.amazonaws.com/all-screens_1gmhgfwwkrkwpefc_.png' />
                </div>
                <div className='get-started-bottom-right'>

                    <div className='get-started-bottom-heading'>
                        A Full-Digital Customer Acquisition Platform to {' '}
                        <span className='get-started-bottom-heading-emphasis'>
                            Grow Your Business
                        </span>
                    </div>
                    <div className='get-started-bottom-content'>
                        With a full time dedicated account manager making sales calls for your business and pushing in customers, ServiceGrace has brought amazing customer acquisition for towing companies, chiropractors, handyman services, massage businesses, and more. To join ServiceGrace is simple-simply order your subscription and immediately you will be transported to our portal with customers who are looking for your business. With immediate access to new customers, ServiceGrace is a revolutionary program guaranteed to see your business receive new customers.
                    </div>
                </div>
                <div className='get-started-bottom-cube'>
                    <img src='https://com-syndafy-dealgrace-static.s3.us-east-2.amazonaws.com/cube_1gmhgfx4krkwtxty_.png' />
                </div>
            </div>
        </div>
    }
}

export default withRouter(GetStarted);